/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A7Inputs */

const et_faq_a7 = /** @type {(inputs: Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI ja automaatika aitavad müüki kasvatada, vastates klientidele kiiremini, vähendades käsitööd ja hoides huvilisi soojana seni, kuni nad on valmis ostma. Näiteks AI-vestlusrobot saab vastata korduvatele küsimustele, koguda kontaktandmeid, kvalifitseerida päringuid ja suunata info otse CRM-i. ScalingWebs kasutab AI-toega sisustrateegiaid, vestluslahendusi ja automaatikaid selleks, et vähendada müügiprotsessi hõõrdumist. Eesmärk on lihtne: ükski hea päring ei tohiks kaduma minna ainult sellepärast, et vastus tuli liiga hilja.`)
};

const en_faq_a7 = /** @type {(inputs: Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI and automation help grow sales by responding to prospects faster, reducing manual work, and keeping leads warm until they are ready to buy. For example, an AI chatbot can answer recurring questions, collect contact details, qualify inquiries, and send information directly to your CRM. ScalingWebs uses AI-assisted content strategies, conversational solutions, and automations to reduce friction in the sales process. The goal is simple: no good inquiry should be lost just because the response came too late.`)
};

/**
* | output |
* | --- |
* | "AI and automation help grow sales by responding to prospects faster, reducing manual work, and keeping leads warm until they are ready to buy. For example, a..." |
*
* @param {Faq_A7Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a7 = /** @type {((inputs?: Faq_A7Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A7Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a7(inputs)
	return en_faq_a7(inputs)
});